export default function loadStyles(src, attributes = {}) {
  const newStyles = document.createElement('link');
  Object.keys(attributes).forEach(key => {
    newStyles.setAttribute(key, attributes[key]);
  });
  newStyles.type = 'text/css';
  newStyles.rel = 'stylesheet';
  newStyles.href = src;
  document.head.insertBefore(newStyles, document.head.childNodes[document.head.childNodes.length - 1].nextSibling);
}